import React from 'react';
import Redo from '../App/Redo';

function HorsUEtoUE() {
  return(
    <div id="HorsUEtoUE" className='paper'>
      <h2>Dropshipping vers l'UE</h2>
      <li>Ventes Exo de TVA</li>
      <li>CA à déclarer sur la déclaration du pays de destination</li>
      <Redo />
    </div>
  )
}

export default HorsUEtoUE